import { ExchangeActionTypes } from '../interfaces';

export const attachExchange = () => ({
  type: ExchangeActionTypes.EXCHANGE_ATTACH_LISTENERS,
});

export const detachExchange = () => ({
  type: ExchangeActionTypes.EXCHANGE_DETACH_LISTENERS,
});
